import { Component, Injector, OnInit } from '@angular/core';
import { BaseComponent } from 'src/app/shared/baseComponent';

@Component({
  selector: 'app-reset',
  templateUrl: './reset.component.html',
  styleUrls: ['./reset.component.css']
})
export class ResetComponent extends BaseComponent {
  userid = ""
  firstname:any = {}
  resettoken = ""
  password = ""
  password2 = ""
  message = ""
  constructor(injector: Injector) { super(injector) }

  async ngOnInit() {
    this.userid = this.getQueryParameter("userid")
    this.firstname = await this.db.get("Authenticate","GetFirstNameById",{id: this.userid})
    this.resettoken = this.getQueryParameter("resettoken")
  }

  async reset() {
    if (this.password != this.password2) {
      this.alert.danger("Entered passwords are not identical")
      return
    }
    if (this.checkPassword(this.password) == false) {
      this.alert.danger("The password must contain at least one of lower case, upper case, number and special character")
      return
    }

    this.loader.show()
    let resp = await this.db.get("Authenticate", "updatePasswordWithToken", { id: this.userid, password: this.password, token: this.resettoken })
    if (resp.success == true){
      this.message = "You succesfully reset your password!"
      //this.alert.success(resp.message)
    }else{
      this.message = "Something went wrong, PLease contact your system administrator."
      //this.alert.danger(resp.message)
    }
    this.loader.hide()
  }

  checkPassword(password: string): boolean {
    const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]+$/;
    return pattern.test(password);
  }

}
